import store from '@/store'
import api from '@/plugins/api'
import Toastify from '@/plugins/toastify'
import lang from '@/plugins/lang'
import { btnLoading } from '@/helpers/DOM'

let requestedChatToast = {}

let receivedMessageToast = {}

let transferChatToast = {}

let originalTitle = document.title

let loopAlert = null

let myAudio = null

function alertWindow(title) {
    removeAlertWindow()

    loopAlert = setInterval(function (){
        if (document.title === title) {
            document.title = originalTitle
        } else {
            document.title = title
        }
    }, 1500)


    if (!myAudio) {
        myAudio = new Audio('/sounds/service-chat.wav');

        if (typeof myAudio.loop == 'boolean') {
            myAudio.loop = true;
        } else {
            myAudio.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play().catch(() => {});
            }, false);
        }
    }

    myAudio.play().catch((err) => {
        console.warn(err)
    });
}

function removeAlertWindow() {
    if (loopAlert) {
        clearInterval(loopAlert)

        document.title = originalTitle
    }

    if (myAudio) {
        myAudio.pause()
    }
}

export function dismissRequestedChat(chatId) {
    if (requestedChatToast[chatId]) {
        requestedChatToast[chatId].hideToast()

        delete requestedChatToast[chatId]

        removeAlertWindow()
    }
}

export function dismissTransferChat(chatId) {
    if (transferChatToast[chatId]) {
        transferChatToast[chatId].hideToast()

        delete transferChatToast[chatId]

        removeAlertWindow()
    }
}

export function createAnswerChatToast(chatId, data) {
    if (Object.values(requestedChatToast).length > 0) {
        return requestedChatToast[chatId]
    }

    alertWindow('Cliente Aguardando no Chat')

    return requestedChatToast[chatId] = Toastify({
        title: data.title,
        text: data.body,
        duration: 0,
        destination: `/${store().prefixUrl}/service-chats?status=waiting`,
        close: false,
        buttons: [
            {
                text: lang.t('common:answer'),
                onClick(event) {
                    eventButtons.answerChatClick(event, chatId)
                },
                class: 'btn-success'
            },
            {
                text: lang.t('common:ignore'),
                onClick: (event) => {
                    event.stopPropagation()

                    dismissRequestedChat(chatId)
                },
                class: 'btn-danger'
            }
        ]
    }).showToast();
}

export function createAcceptTransferChatToast(chatId, data) {
    if (transferChatToast[chatId]) {
        return transferChatToast[chatId]
    }

    alertWindow('Transferência de Chat')

    return transferChatToast[chatId] = Toastify({
        title: data.title,
        text: data.body,
        duration: 0,
        close: false,
        buttons: [
            {
                text: lang.t('common:accept'),
                onClick(event) {
                    eventButtons.acceptTransferChatClick(event, chatId)
                },
                class: 'btn-success'
            },
            {
                text: lang.t('common:refuse'),
                onClick: (event) => {
                    eventButtons.refuseTransferChatClick(event, chatId)

                    dismissTransferChat(chatId)
                },
                class: 'btn-danger'
            }
        ]
    }).showToast();
}

export function createReceivedMessage(chatId, data) {
    if (receivedMessageToast[chatId]) {
        receivedMessageToast[chatId].hideToast()
    }

    return receivedMessageToast[chatId] = Toastify({
            title: data.title,
            text: data.body,
            destination: data.link,
        }).showToast();
}

const eventButtons = {
    answerChatClick(event, chatId) {
        event.stopPropagation()

        btnLoading.start(event.target)

        api('/panel-agent/service-chats/accept/next-request', {
            method: 'POST',
        })
            .then(data => {
                if (!data) {
                    dismissRequestedChat(chatId)

                    return
                }

                window.location = `/${store().prefixUrl}/service-chats`
            })
            .catch(() => {
                btnLoading.finish(event.target)
            })
    },

    acceptTransferChatClick(event, chatId) {
        event.stopPropagation()

        btnLoading.start(event.target)

        api(`/panel-agent/service-chats/${chatId}/accept/agent-transfer`, {
            method: 'POST',
        })
            .then(() => {
                window.location = `/${store().prefixUrl}/service-chats`
            })
            .catch(error => {
                if (error.status && error.status >= 500) {
                    btnLoading.finish(event.target)
                } else {
                    dismissTransferChat(chatId)
                }
            })
    },

    refuseTransferChatClick(event, chatId) {
        event.stopPropagation()

        api(`/panel-agent/service-chats/${chatId}/cancel/agent-transfer`, {
            method: 'POST',
            ignoreCode: '*',
        })
    }
}

export { eventButtons }
